export default {
	canvas: null,
	drawOption: 0,
	drawOptions: [],

	init() {
		this.canvas = document.querySelector("#canvas-404");

		if (!this.canvas) {
			return;
		}

		this.items = Array.from(this.canvas.querySelectorAll(".num-404"));

		this.drawOptions = ["drawArrow", "drawQuestionMark", "drawCross"];

		this.items.forEach((item) => {
			item.handlePointerEnter = () => {
				const index = this.items.indexOf(item);

				this.items.forEach((item) => item.classList.remove("is-active"));

				if (Math.random() > 0.9) {
					this.drawOption = (this.drawOption + 1) % this.drawOptions.length;
				}

				this[this.drawOptions[this.drawOption]](index);
			};

			item.addEventListener("pointerenter", item.handlePointerEnter);
		});
	},

	drawCross(fromIndex) {
		const points = [0, -34, -32, 34, 32, -34 - 34, -34 - 30, 34 + 34, 34 + 30];

		this.drawPoints(fromIndex, points);
	},

	drawArrow(fromIndex) {
		const points = [
			-33 - 34,
			-33,
			-9,
			-8,
			-7,
			-6,
			-5,
			-4,
			-3,
			-2,
			-1,
			0,
			1,
			33,
			32 + 33,
		];

		this.drawPoints(fromIndex, points);
	},

	drawQuestionMark(fromIndex) {
		const points = [
			0,
			-32,
			-32 - 32,
			-32 - 31 - 35,
			-32 - 31 - 36,
			-32 - 31 - 37,
			-32 - 32 - 4,
			33 + 33,
		];

		this.drawPoints(fromIndex, points);
	},

	drawPoints(fromIndex, points) {
		const options = `1234567890@$^(_['/`;

		this.items[fromIndex].innerText = options.charAt(
			Math.floor(Math.random() * options.length),
		);

		points
			.map((p) => p + fromIndex)
			.filter((p) => p >= 0 && p < this.items.length - 1)
			.forEach((point) => {
				this.items[point].classList.add("is-active");
			});
	},

	destroy() {
		if (!this.items) {
			return;
		}

		this.items.forEach((item) => {
			item.removeEventListener("pointerenter", item.handlePointerEnter);

			delete item.handlePointerEnter;
		});

		this.items = null;
		this.canvas = null;
		this.drawOption = 0;
		this.drawOptions = [];
	},
};
